<template>
  <div
    class="vue-pull-to-wrapper"
    ref="vue-pull-to-wrapper"
    :style="{ height: wrapperHeight }"
    @transitionend="handleTransitionEnd"
  >
    <div
      v-if="topLoadMethod"
      :style="{ height: `${topBlockHeight}px`, marginTop: `${-topBlockHeight}px` }"
      class="action-block action-block-top"
      ref="action-block-top"
    >
      <slot
        name="top-block"
        :state="state"
        :state-text="topText"
        :trigger-distance="_topConfig.triggerDistance"
        :diff="diff"
      >
        <p class="default-text">
          {{ topText }}
        </p>
      </slot>
    </div>
    <div
      ref="scroll-container"
      class="scroll-container"
    >
      <slot />
      <div
        v-if="bottomLoadMethod && isBottomKeepScroll"
        class="bottom-filler"
        ref="bottom-filler"
      />
    </div>
    <div
      v-if="bottomLoadMethod"
      :style="{ height: `${bottomBlockHeight}px`, marginBottom: `${-bottomBlockHeight}px` }"
      class="action-block action-block-bottom"
      ref="action-block-bottom"
    >
      <slot
        name="bottom-block"
        :state="state"
        :state-text="bottomText"
        :trigger-distance="_bottomConfig.triggerDistance"
        :diff="diff"
      >
        <p class="default-text">
          {{ bottomText }}
        </p>
      </slot>
    </div>
  </div>
</template>
<script>
import PullTo from 'vue-pull-to';

export default {
  name: 'PullTo',
  extends: PullTo,
};
</script>

<style lang="scss">
  .vue-pull-to-wrapper{
    background-color: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
  }
</style>
